import React from 'react';

// Components
import { CenterViewLayout } from 'components/core/layouts/center';
import { Button } from 'components/core/button';
import * as Sentry from '@sentry/react'

function Fallback({error}){
  return <CenterViewLayout>
          <p className="my-3">{`Oups. Il y a eu une erreur dans l'app.`}</p>

          <Button color="default" size="lg" block href="/">{`Retour à l'accueil`}</Button>
          <div className="p-3 text-sm text-red-600 mt-3 bg-gray-50 rounded-lg">
            <p>{`Message d'erreur`}</p>
            <code>{error.toString()}</code> 
          </div>
         </CenterViewLayout>
}

export function ErrorBoundary({children}){
  return <Sentry.ErrorBoundary fallback={Fallback}>
          {children}
          </Sentry.ErrorBoundary>
}